import { render, staticRenderFns } from "./shareInfoItemList.vue?vue&type=template&id=797ab3ab&scoped=true"
import script from "./shareInfoItemList.vue?vue&type=script&lang=js"
export * from "./shareInfoItemList.vue?vue&type=script&lang=js"
import style0 from "./shareInfoItemList.vue?vue&type=style&index=0&id=797ab3ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ab3ab",
  null
  
)

export default component.exports